import Immutable from 'immutable';

const Content: {
  keyword: string,
  ascending: boolean
} = {
  keyword: '',
  ascending: true
};

class SortOrder extends Immutable.Record(Content) {
}

export default SortOrder;
